/**
 * 路由配置文件
 */
export default function () {
  return [{
    permission: 'all',
    route: {
      path: '/',
      name: '/',
      redirect: '/yanbao-search',
      meta: [],
      component: () => import('../pages/nil/index')
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/home',
      name: 'home',
      meta: [],
      component: () => import('../pages/home/index')
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/login',
      name: 'login',
      meta: [],
      component: () => import('../pages/login/index')// 登录
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/forget-pass',
      name: 'forget-pass',
      meta: [],
      component: () => import('../pages/login/forgetPass.vue')// 登录
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/registry',
      name: 'registry',
      meta: [],
      component: () => import('../pages/registry/index')// 注册
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/yanbao-active',
      name: 'yanbao-active',
      meta: [],
      component: () => import('../pages/yanbao-active/index')// 延保激活
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/yanbao-personal',
      name: 'yanbao-personal',
      meta: [],
      component: () => import('../pages/personal/index.vue')// 个人中心
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/yanbao-buy',
      name: 'yanbao-buy',
      meta: [],
      component: () => import('../pages/yanbao-buy/index')// 延保购买
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/yanbao-complaint',
      name: 'yanbao-complaint',
      meta: [],
      component: () => import('../pages/yanbao-complaint/index')// 在线申诉
    }
  }, {
    isCache: false,
    permission: 'all',
    route: {
      path: '/yanbao-search',
      name: 'yanbao-search',
      meta: [],
      component: () => import('../pages/yanbao-search/index') // 延保查询
    }
  }];
};



// WEBPACK FOOTER //
// ./src/app/sitmap.js